import { render, staticRenderFns } from "./Add_scale.vue?vue&type=template&id=3f5fbf9a"
import script from "./Add_scale.vue?vue&type=script&lang=js"
export * from "./Add_scale.vue?vue&type=script&lang=js"
import style0 from "./Add_scale.vue?vue&type=style&index=0&id=3f5fbf9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports